const ns = "MODULE_EVENT_CATERING";
export const SAVE_RECEIVE = `${ns}_SAVE_RECEIVE`;
export const SAVE_REQUEST = `${ns}_SAVE_REQUEST`;
export const CLEAR_LAST_SAVE = `${ns}_CLEAR_LAST_SAVE`;
export const ERROR = `${ns}_ERROR`;
export const CLEAR_ERROR = `${ns}_CLEAR_ERROR`;
